module.exports = "/images/risk-slideshow-3.png?5f676a9346d5edf819237c8bcab24995";